/*
 * AccountLocked Messages
 *
 * This contains all the text for the AccountLocked component.
 *
 */

import { defineMessages } from "utils/defineMessages";

export const scope = "app.components.AccountLocked";

export default defineMessages(scope, {
  header: "Account locked",
  description:
    "Your account is in a locked state. Please contact your system administrator for further assistance.",
  invalidCodeHeader: "Activation link invalid",
  emailExpiredDesc: "Activation link expired. Please contact administrator",
  invalidCodeDesc: " Contact your administrator for further assistance. ",
  errorHeader: "An error has occurred",
  errorDesc: "Please contact your system administrator.",
});
